/**
 * 自动加载 ./modules 下所有内容 不需要手动 import
 *
 * 事例：
 * 假设文件结构为：
 *
 * ./modules
 *   module1.ts
 *   module2.ts
 *   module3.ts
 *
 * 则变量 modules 拿到的内容会是：
 *
 * {
 *   module1: value1,
 *   module2: value2,
 *   module3: value3,
 * }
 * value1、value2、value3 分别为该文件 export default 的内容
 */

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.ts$/);

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

export default (moduleName) => (moduleName ? modules[moduleName] : moduleName);
